<template>
  <b-modal id="DigitalSignatureAnswersModal" :title="$t('DigitalSignatureAnswers')"
           ok-only :ok-title="$t('Close')" size="lg" no-close-on-backdrop>
    <div v-if="isLoading" class="text-center py-4">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div v-else-if="answersData">
      <b-table-simple bordered small responsive>
        <b-thead head-variant="light">
          <b-tr>
            <b-th style="width:50px;">#</b-th>
            <b-th>{{ $t('Question') }}</b-th>
            <b-th style="width:100px;">{{ $t('Answer') }}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(answer, index) in answersData.answers" :key="index">
            <b-td>{{ index + 1 }}</b-td>
            <b-td>
              {{ answer.questionText }}
              <!-- Danışanın yazdığı açıklama sorunun ALTINA iner: cevabın kendisi değil
                   GEREKÇESİdir ve uzun metin Evet/Hayır sütununu sıkıştırmamalı. -->
              <p v-if="answer.answerDetail" class="answer-detail mb-0">{{ answer.answerDetail }}</p>
            </b-td>
            <b-td>
              <b-badge :variant="answer.answer ? 'success' : 'danger'">
                {{ answer.answer ? $t('Yes') : $t('No') }}
              </b-badge>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <div class="mt-3 text-muted small">
        <div v-if="answersData.verifiedAt">
          <strong>{{ $t('ApprovalDate') }}:</strong> {{ answersData.verifiedAt }}
        </div>
        <div v-if="answersData.ipAddress">
          <strong>{{ $t('ApproverIPAddress') }}:</strong> {{ answersData.ipAddress }}
        </div>
      </div>
    </div>
    <div v-else class="text-center py-4 text-muted">
      {{ $t('NoData') }}
    </div>
  </b-modal>
</template>

<script>
  import axios from '../../services/index'

  export default {
    name: 'DigitalSignatureAnswersModal',
    data() {
      return {
        answersData: null,
        isLoading: false
      }
    },
    methods: {
      open(customerConsentFormId) {
        this.answersData = null;
        this.isLoading = true;
        this.$bvModal.show('DigitalSignatureAnswersModal');
        this.fetchAnswers(customerConsentFormId);
      },
      async fetchAnswers(customerConsentFormId) {
        try {
          const response = await axios.get('/ConsentForm/GetDigitalSignatureAnswers?customerConsentFormId=' + customerConsentFormId);
          this.answersData = response.data;
        } catch {
          this.$toastr.error(this.$t('Error'));
        } finally {
          this.isLoading = false;
        }
      }
    }
  }
</script>

<style scoped>
  .answer-detail {
    margin-top: 4px;
    padding-left: 8px;
    border-left: 2px solid #e3e6ea;
    font-size: 13px;
    color: #6c757d;
    white-space: pre-wrap;
    word-break: break-word;
  }
</style>
